// Progressiv forbedring af [data-tabs]: serveren renderer alle paneler synlige og
// en skjult tablist. Med JS bliver det en ARIA-tablist, hvor kun ét panel vises ad gangen.

let instance = 0;

function enhance(root: HTMLElement): void {
    const list = root.querySelector<HTMLElement>('[role="tablist"]');
    const tabs = Array.from(root.querySelectorAll<HTMLButtonElement>('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll<HTMLElement>('[role="tabpanel"]'));
    if (!list || tabs.length === 0 || tabs.length !== panels.length) return;

    const id = `tabs${++instance}`;
    tabs.forEach((tab, i) => {
        tab.id = `${id}-tab${i}`;
        tab.setAttribute('aria-controls', `${id}-panel${i}`);
        panels[i].id = `${id}-panel${i}`;
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
    });

    const select = (index: number, focus: boolean): void => {
        tabs.forEach((tab, i) => {
            const selected = i === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels[i].hidden = !selected;
        });
        if (focus) tabs[index].focus();
    };

    list.addEventListener('click', (e: MouseEvent) => {
        const tab = (e.target as Element).closest<HTMLButtonElement>('[role="tab"]');
        if (tab) select(tabs.indexOf(tab), false);
    });

    list.addEventListener('keydown', (e: KeyboardEvent) => {
        const current = tabs.indexOf(document.activeElement as HTMLButtonElement);
        if (current < 0) return;
        const last = tabs.length - 1;
        const next =
            e.key === 'ArrowRight' ? (current === last ? 0 : current + 1) :
            e.key === 'ArrowLeft' ? (current === 0 ? last : current - 1) :
            e.key === 'Home' ? 0 :
            e.key === 'End' ? last : -1;
        if (next < 0) return;
        e.preventDefault();
        select(next, true);
    });

    list.hidden = false;
    root.classList.add('is-tabbed');
    select(0, false);
}

document.querySelectorAll<HTMLElement>('[data-tabs]').forEach(enhance);

export {};
